export type ShareResult = 'shared' | 'copied' | 'cancelled'

type ShareTarget = Pick<Navigator, 'clipboard'> & { share?: Navigator['share'] }

/** Opens the system's share sheet when there is one, else copies the link. */
export async function shareLink(
  target: ShareTarget,
  data: { title: string; text: string; url: string },
): Promise<ShareResult> {
  if (target.share) {
    try {
      await target.share(data)
      return 'shared'
    } catch (e) {
      if (e instanceof DOMException && e.name === 'AbortError') return 'cancelled'
    }
  }
  await target.clipboard.writeText(data.url)
  return 'copied'
}
